import PropTypes, { bool } from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import { Input, Label } from "./Styles";

CityField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  label: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  autoComplete: PropTypes.oneOf(["on", "off"]),
  style: PropTypes.object,
  disabled: bool,
};

export function CityField({
  value = "",
  onChange,
  label = "City",
  name = "city",
  placeholder = "City",
  hideInternalFocusStyles = false,
  autoComplete = "off",
  style,
  disabled,
}) {
  return (
    <Wrapper style={style}>
      <Label htmlFor={name}>{label}</Label>
      <Input
        id={name}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        hideInternalFocusStyles={hideInternalFocusStyles}
        autoComplete={autoComplete}
        disabled={disabled}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  box-sizing: border-box;
  border-right: 1px solid #e5e5e5;
  padding: 6px;
  flex: 1;
  min-width: 120px;

  @media (max-width: 430px) {
    width: 100%;
    border-bottom: 1px solid #e5e5e5;
    height: 45.5px;
  }
`;
